import React, { useContext, useRef, useState } from "react";
import logo from "../../static/HungHau.png";
import { FiMenu, FiLogOut } from "react-icons/fi";
import { getMail } from "../../utils/services";
import { useMsal } from "@azure/msal-react";
import { Link, useNavigate } from "react-router-dom";
import { GlobalState } from "../../GlobalState";

const CSS_design = {
  li: "px-4 py-2 cursor-pointer hover:text-blue-600 transition-colors duration-200 relative font-medium",
};

export default function Header() {
  const state = useContext(GlobalState);
  const [isAdmin, setIsAdmin] = state.isAdmin;
  const [admin, setAdmin] = state.admin;
  const [openTask, setOpenTask] = useState(null);

  const [showMenu, setShowMenu] = useState(false);
  const navigate = useNavigate();
  const headerRef = useRef(null);
  const { instance } = useMsal();
  const mail = getMail();

  const LogOut = async () => {
    sessionStorage.clear();
    localStorage.clear();
    if (mail) {
      instance.logoutRedirect({
        postLogoutRedirectUri: window.location.origin,
      });
    } else {
      window.location.reload();
    }
  };

  // Scroll to section by id
  const scrollToSection = (id) => {
    setShowMenu(false);
    setTimeout(() => {
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
    }, 200); // Wait for menu to close
  };

  // Mobile menu items for scroll
  const mobileSections = [
    { id: "section-doithi", label: "ĐỘI THI" },
    { id: "section-nhiemvu", label: "NHIỆM VỤ" },
    { id: "section-xephang", label: "XẾP HẠNG" },
    { id: "section-giaithuong", label: "GIẢI THƯỞNG" },
  ];

  const TaskPopup = ({ task, onClose }) => (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
      <div className="bg-[#0091EB]/90 rounded-2xl shadow-xl max-w-2xl max-md:max-w-full max-md:mx-4 w-full py-4 relative animate-fadeIn">
        <div className="transform -translate-y-8 scale-[1.02] border w-full bg-gradient-to-b from-[#07B4FE] to-[#0044D7] rounded-3xl relative z-10 flex items-center justify-center leading-tight h-fit p-4">
          <button
            className="absolute top-2 right-4 text-2xl text-white hover:text-red-500"
            onClick={onClose}
          >
            &times;
          </button>
          <h2 className="bg-gradient-to-b leading-normal text-5xl max-lg:text-2xl text-center from-[#FFD942] via-[#FFA22F] to-[#FF7E22] bg-clip-text text-transparent font-bold">
            LIÊN HỆ HỖ TRỢ
          </h2>
        </div>
        <div className="text-white text-xl px-6">
          <h3>TRUNG TÂM TRUYỀN THÔNG</h3>
          <span>
            Ông Hoàng Xuân Ái - Phó Giám đốc <br /> Email: aihx@hunghau.vn <br /> Phone:
            0967500333
          </span>
          <h3 className="mt-4">KHỐI CÔNG NGHỆ</h3>
          <span>
            Ông Phạm Văn Thi - Trưởng phòng <br /> Email: thipv@hexagon.xyz <br /> 
            Phone: +84979800280
          </span>
        </div>
      </div>
    </div>
  );

  return (
    <div
      ref={headerRef}
      className="w-11/12 max-md:w-full mx-auto md:flex md:items-center md:justify-between justify-between p-[15px] min-h-[100px] px-[20px]"
    >
      {openTask && (
        <TaskPopup task={openTask} onClose={() => setOpenTask(null)} />
      )}
      {/* Logo & Menu Icon */}
      <div className="flex basis-[30%] max-md:justify-between md:justify-start md:w-[20%] items-center">
        <Link
          to="/"
          className="transform hover:scale-105 transition-transform duration-200"
        >
          <img
            src={logo}
            alt="Logo"
            className="w-[80px] object-cover mr-[15px] cursor-pointer hover:opacity-90 transition-opacity"
          />
        </Link>
        <FiMenu
          size={"30px"}
          className="md:hidden cursor-pointer hover:text-blue-600 transition-colors duration-200 transform hover:scale-110"
          onClick={() => setShowMenu(!showMenu)}
        />
      </div>

      {/* Desktop Menu */}
      <div className="flex gap-6 max-md:hidden text-base text-white items-center basis-[70%] justify-center">
        <li
          className="text-white list-none relative w-fit cursor-pointer  group"
          onClick={() => scrollToSection("section-doithi")}
        >
          <span className="relative z-10 font-normal">ĐỘI THI</span>
          <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-gradient-to-r from-blue-500 to-indigo-600 group-hover:w-full transition-all duration-300"></span>
        </li>
        <li
          className="text-white list-none relative cursor-pointer group"
          onClick={() => scrollToSection("section-nhiemvu")}
        >
          <span className="relative z-10 font-normal">NHIỆM VỤ</span>
          <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-gradient-to-r from-blue-500 to-indigo-600 group-hover:w-full transition-all duration-300"></span>
        </li>
        <li
          className="text-white list-none relative cursor-pointer group"
          onClick={() => scrollToSection("section-xephang")}
        >
          <span className="relative z-10 font-normal">XẾP HẠNG</span>
          <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-gradient-to-r from-blue-500 to-indigo-600 group-hover:w-full transition-all duration-300"></span>
        </li>
        <li
          className="text-white list-none relative cursor-pointer group"
          onClick={() => scrollToSection("section-giaithuong")}
        >
          <span className="relative z-10 font-normal">GIẢI THƯỞNG</span>
          <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-gradient-to-r from-blue-500 to-indigo-600 group-hover:w-full transition-all duration-300"></span>
        </li>
      </div>

      {/* Desktop Right Menu */}
      <ul
        className={`${
          showMenu
            ? "opacity-100 transform translate-y-0"
            : "opacity-0 md:opacity-100 transform -translate-y-2 md:translate-y-0 hidden md:flex"
        } md:flex max-md:hidden justify-end transition-all duration-300 ease-in-out basis-[30%]`}
      >
        <li
          onClick={() => setOpenTask(true)}
          className="px-4 py-2 text-base text-white hover:cursor-pointer hover:text-white transition-all duration-300 rounded-[66px] bg-gradient-to-br from-[#F10380] to-[#00FCED]"
        >
          LIÊN HỆ
        </li>
        <li
          onClick={LogOut}
          className={`${CSS_design.li} group flex items-center gap-2 ml-4 bg-red-50 hover:bg-red-100 rounded-full px-6 py-2 text-red-600 hover:text-red-700 transition-all duration-300 transform hover:scale-105`}
        >
          <FiLogOut className="text-lg group-hover:rotate-90 transition-transform duration-300" />
          <span>Đăng xuất</span>
        </li>
      </ul>

      {/* Mobile Drawer Menu */}
      {showMenu && (
        <div
          className="fixed inset-0 bg-black bg-opacity-40 z-50 md:hidden"
          onClick={() => setShowMenu(false)}
        >
          <div
            className="absolute top-0 right-0 w-3/4 max-w-xs h-full bg-white shadow-lg flex flex-col p-6 gap-4"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="self-end mb-4 text-gray-600 text-2xl"
              onClick={() => setShowMenu(false)}
            >
              &times;
            </button>
            {mobileSections.map((section) => (
              <div
                key={section.id}
                className="py-2 border-b text-[#0253e1] font-semibold cursor-pointer"
                onClick={() => scrollToSection(section.id)}
              >
                {section.label}
              </div>
            ))}
            <div
              onClick={() => setOpenTask(true)}
              className="py-2 border-b text-[#0253e1] font-semibold"
            >
              LIÊN HỆ
            </div>
            <button
              onClick={() => {
                setShowMenu(false);
                LogOut();
              }}
              className="flex items-center gap-2 mt-4 text-red-600 font-semibold"
            >
              <FiLogOut />
              Đăng xuất
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
